import { createStore } from 'vuex'

// modulos
import moduloApp from './modules/app'
import moduloSesion from './modules/sesion'
import moduloGarantias from './modules/garantias'
import moduloSolicitudes from './modules/solicitudes'
import moduloNoticias from './modules/noticias'
import moduloAvisosImportantes from './modules/avisosImportantes'
import moduloGestionNoticias from './modules/gestionNoticias'
import moduloPerfil from './modules/perfil'
import moduloContacto from './modules/contacto'
import moduloForo from './modules/foro'
import moduloArchivos from './modules/archivos'
import moduloPedidos from './modules/pedidos'
import moduloProductos from './modules/productos'
import moduloPresupuestos from './modules/presupuestos'
import moduloPedidosADistribuidores from './modules/pedidosADistribuidores'
import moduloPedidosSubagentes from './modules/pedidosSubagentes'
import moduloCuentaCorriente from './modules/cuentaCorriente'
import moduloResumenDeCuenta from './modules/resumenDeCuenta'
import moduloClientes from './modules/clientes'

export default createStore({

  modules: {
    app: moduloApp,
    sesion: moduloSesion,
    garantias: moduloGarantias,
    solicitudes: moduloSolicitudes,
    noticias: moduloNoticias,
    avisosImportantes: moduloAvisosImportantes,
    gestionNoticias: moduloGestionNoticias,
    perfil: moduloPerfil,
    contacto: moduloContacto,
    foro: moduloForo,
    pedidos: moduloPedidos,
    archivos: moduloArchivos,
    productos: moduloProductos,
    presupuestos: moduloPresupuestos,
    pedidosADistribuidores: moduloPedidosADistribuidores,
    pedidosSubagentes: moduloPedidosSubagentes,
    cuentaCorriente: moduloCuentaCorriente,
    resumenDeCuenta: moduloResumenDeCuenta,
    clientes: moduloClientes
  }

})
